








import { defineComponent, ref, watch } from '@nuxtjs/composition-api';
import { debounce, isEqual } from 'lodash-es';

export default defineComponent({
  name: 'ToggleInput',
  props: {
    value: {
      type: [Boolean, String, Object, Array],
      required: true,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    trueValue: {
      type: [String, Object, Number, Boolean],
      default: true,
    },
    falseValue: {
      type: [String, Object, Number, Boolean, Array],
      default: false,
    },
  },
  setup(props, { emit }) {
    const innerValue = ref<boolean>(isEqual(props.value, props.trueValue));

    watch(
      innerValue,
      debounce(newValue => {
        if (newValue) {
          emit('input', props.trueValue);
        } else {
          emit('input', props.falseValue);
        }
      }, 200)
    );

    watch(
      () => props.value,
      debounce(newValue => {
        innerValue.value = isEqual(newValue, props.trueValue);
      }, 200)
    );

    return {
      innerValue,
    };
  },
});
